export default __webpack_public_path__ + "static/media/resume.528edbd3.pdf";